import useTimeZoneClock from "hooks/useTimeZoneClock";
import { getBackgroundStyle } from "components/common/TableColor";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";

const ViewTable = React.memo(({ item }) => {
  const timeZone = useTimeZoneClock(item?.datetime);
  const formattedDate = moment(timeZone).format("MMMM DD YYYY");
  const formattedTime = moment(timeZone).format("hh:mm A");
  const InfoRow = ({ label, value, toLowerCase = "" }) => (
    <div className="row_detail_tab">
      <div className="label_view">
        <strong>{label}</strong>
      </div>
      <div className={`detail_view ${toLowerCase}`}>{value || "N/A"}</div>
    </div>
  );
  const rowDash1Style = {
    display: "flex",
    alignItems: "normal",
    width: "100%",
    gap: "1rem",
  };
  const rowDash2Style = {
    display: "block",
    alignItems: "normal",
    width: "100%",
    gap: "1rem",
  };
  const marginTopZero = {
    marginTop: 0,
  };
  console.log("item", item);
  return (
    <div className="Table_data_show Table_data_show1 p-0 overflow-auto">
      {item?.type !== "2" ? (
        <div className="row_dash_1" style={rowDash2Style}>
          <div className="Table_data_show Table_data_show1 pt-0">
            <h2 className="ps-3 pt-2 pb-2">Basic Information</h2>
            <table className="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "20%" }}>
                    Email:
                  </td>
                  <td className="bg-primary-secondary">
                    {item?.appointment_details?.email || "N/A"}
                  </td>
                  <td className="bg-primary-secondary">Today's Date:</td>
                  <td className="bg-primary-secondary">
                    {moment(
                      item?.appointment_details?.todays_date,
                      "YYYY-MM-DD"
                    ).format("MMM D, YYYY") || "N/A"}
                  </td>
                  <td className="bg-primary-secondary">Contact Person Name:</td>
                  <td className="bg-primary-secondary">
                    {item?.appointment_details?.contact_person_name || "N/A"}
                  </td>
                </tr>
                {/* <tr>
                                <td className="bg-primary-secondary">Zone:</td>
                                <td className="bg-primary-secondary" colSpan={5}>{item?.school?.name || 'N/A'}</td>
                            </tr> */}
                <tr>
                  <td className="bg-primary-secondary">School:</td>
                  <td className="bg-primary-secondary" colSpan={5}>
                    {item?.school?.name || "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="Table_data_show Table_data_show1 pt-0">
            <h2 className="ps-3 pt-2 pb-2">Meeting Request Info</h2>
            <table className="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "20%" }}>
                    Meeting Format:
                  </td>
                  <td className="bg-primary-secondary">
                    {item?.meeting_format || "N/A"}
                  </td>
                  <td className="bg-primary-secondary">End Before 4PM:</td>
                  <td className="bg-primary-secondary">
                    {item?.appointment_details?.meeting_end_before_4pm || "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="Table_data_show Table_data_show1 pt-0">
            <h2 className="ps-3 pt-2 pb-2">Type Of Metting</h2>
            <table className="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "20%" }}>
                    Type Of Meeting:
                  </td>
                  <td className="bg-primary-secondary">
                    {item?.appointment_details?.meeting_type || "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="Table_data_show Table_data_show1 pt-0">
            <h2 className="ps-3 pt-2 pb-2">Meeting Details</h2>
            <table className="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "20%" }}>
                    Meeting Type Other:
                  </td>
                  <td className="bg-primary-secondary">
                    {item?.appointment_details?.meeting_type_other || "N/A"}
                  </td>
                  <td className="bg-primary-secondary">Meeting Date:</td>
                  <td className="bg-primary-secondary">
                    {moment(item?.date, "YYYY-MM-DD").format("MMM D, YYYY") ||
                      "N/A"}
                  </td>
                  <td className="bg-primary-secondary">Start Time:</td>
                  <td className="bg-primary-secondary">
                    {item?.start_time || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td className="bg-primary-secondary">End Time:</td>
                  <td className="bg-primary-secondary">
                    {item?.end_time || "N/A"}
                  </td>
                  <td className="bg-primary-secondary">Reporting Person:</td>
                  <td className="bg-primary-secondary">
                    {item?.appointment_details?.reporting_person || "N/A"}
                  </td>
                  <td className="bg-primary-secondary">
                    Additional Contact #:
                  </td>
                  <td className="bg-primary-secondary">
                    {item?.appointment_details?.additional_contact_number ||
                      "N/A"}
                  </td>
                </tr>
                <tr>
                  <td className="bg-primary-secondary">Specific to Student:</td>
                  <td className="bg-primary-secondary">
                    {item?.school?.name || "N/A"}
                  </td>
                  <td className="bg-primary-secondary">
                    Meeting Location Phone Number:
                  </td>
                  <td className="bg-primary-secondary">
                    {item?.meeting_location_number || "N/A"}
                  </td>
                  <td className="bg-primary-secondary">
                    Room Number or location at site:
                  </td>
                  <td className="bg-primary-secondary" colSpan={5}>
                    {item?.room_number_at_site || "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="Table_data_show Table_data_show1 pt-0">
            <h2 className="ps-3 pt-2 pb-2">Student Info</h2>
            <table className="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "20%" }}>
                    Student Name:
                  </td>
                  <td className="bg-primary-secondary">
                    {item?.appointment_details?.student_name || "N/A"}
                  </td>
                  <td className="bg-primary-secondary">Parent Name:</td>
                  <td className="bg-primary-secondary">
                    {item?.appointment_details?.parent_name || "N/A"}
                  </td>
                  <td className="bg-primary-secondary">Parent Contact:</td>
                  <td className="bg-primary-secondary">
                    {item?.appointment_details?.parent_contact_number || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td className="bg-primary-secondary">Student Perm ID:</td>
                  <td className="bg-primary-secondary">
                    {item?.appointment_details?.student_perm_id || "N/A"}
                  </td>
                  <td className="bg-primary-secondary">
                    School Student Currently Attends:
                  </td>
                  <td className="bg-primary-secondary" colSpan={5}>
                    {item?.student_school?.name || "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="Table_data_show Table_data_show1 pt-0">
            <h2 className="ps-3 pt-2 pb-2">Language</h2>
            <table className="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "20%" }}>
                    Language:
                  </td>
                  {/* <td className="bg-primary-secondary">{item?.language?.name || item?.language_id || 'N/A'}</td>
                                <td className="bg-primary-secondary">{item?.vendor_languages?.length > 0? item.vendor_languages.map(lang => lang.name).join(", "): "N/A"}</td> */}
                  <td className="bg-primary-secondary">
                    {item?.language?.name}
                  </td>
                  <td className="bg-primary-secondary">Other Language:</td>
                  <td className="bg-primary-secondary">
                    {item?.language_other || "N/A"}
                  </td>
                  <td className="bg-primary-secondary">Dialect:</td>
                  <td className="bg-primary-secondary">
                    {item?.appointment_details?.dialect || "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="Table_data_show Table_data_show1 pt-0">
            <h2 className="ps-3 pt-2 pb-2">Request Details</h2>
            <table className="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "20%" }}>
                    Important Information:
                  </td>
                  <td className="bg-primary-secondary" colSpan={5}>
                    {item?.appointment_details?.important_information || "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="Table_data_show Table_data_show1 pt-0">
            <h2 className="ps-3 pt-2 pb-2">Interpreter Information</h2>
            <table className="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "20%" }}>
                    Name:
                  </td>
                  {/* <td className="bg-primary-secondary" colSpan={5}>{item?.interpreter?.user?.name || 'N/A'}</td>
                                <td className="bg-primary-secondary" colSpan={5}>{item?.vendor_interpreter? `${item.vendor_interpreter.first_name}${item.vendor_interpreter.last_name ? ' ' + item.vendor_interpreter.last_name : ''}`: 'N/A'}</td> */}
                  <td className="bg-primary-secondary" colSpan={5}>
                    {item?.status === "pending"
                      ? "N/A"
                      : item?.vendor_id === null
                      ? item?.interpreter?.user?.name || "N/A"
                      : item?.vendor_interpreter
                      ? `${item.vendor_interpreter.first_name}${
                          item.vendor_interpreter.last_name
                            ? " " + item.vendor_interpreter.last_name
                            : ""
                        }${
                          item?.vendor_user?.name
                            ? " - " + 'Excel'
                            : ""
                        }`
                      : "N/A"}
                  </td>

                  <td className="bg-primary-secondary" style={{ width: "20%" }}>
                    Email:
                  </td>
                  {/* <td className="bg-primary-secondary" colSpan={5}>{item?.interpreter?.user?.email || 'N/A'}</td>
                                <td className="bg-primary-secondary" colSpan={5}>{item?.vendor_interpreter?.email || 'N/A'}</td> */}
                  <td className="bg-primary-secondary" colSpan={5}>
                    {item?.status === "pending"
                      ? "N/A"
                      : item?.vendor_id === null
                      ? item?.interpreter?.user?.email || "N/A"
                      : item?.vendor_interpreter?.email || "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className="row_dash_1" style={rowDash2Style}>
          <div className="Table_data_show Table_data_show1 pt-0">
            <h2 className="ps-3 pt-2 pb-2">Basic Information</h2>
            <table className="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "20%" }}>
                    Email:
                  </td>
                  <td className="bg-primary-secondary">
                    {item?.appointment_details?.email || "N/A"}
                  </td>
                  <td className="bg-primary-secondary">Full Name:</td>
                  <td className="bg-primary-secondary">
                    {item?.appointment_details?.contact_person_name || "N/A"}
                  </td>
                </tr>
                {/* <tr>
                                <td className="bg-primary-secondary">Zone:</td>
                                <td className="bg-primary-secondary" colSpan={5}>{item?.school?.name || 'N/A'}</td>
                            </tr> */}
                <tr>
                  <td className="bg-primary-secondary">contact</td>
                  <td className="bg-primary-secondary" colSpan={5}>
                    {item?.appointment_details?.additional_contact_number ||
                      "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="Table_data_show Table_data_show1 pt-0">
            <h2 className="ps-3 pt-2 pb-2">Language</h2>
            <table className="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "20%" }}>
                    language:
                  </td>
                  <td className="bg-primary-secondary">
                    {item?.language.name || "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="Table_data_show Table_data_show1 pt-0">
            <h2 className="ps-3 pt-2 pb-2">Exam Request Information</h2>
            <table className="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "20%" }}>
                    Format for Meeting:
                  </td>
                  <td className="bg-primary-secondary" colSpan={5}>
                    {item?.meeting_format || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "20%" }}>
                    previous_exam:
                  </td>
                  <td className="bg-primary-secondary" style={{ width: "40%" }}>
                    {item?.previous_exam || "N/A"}
                  </td>
                  <td className="bg-primary-secondary">retake_section:</td>
                  <td className="bg-primary-secondary">
                    {item?.retake_section || "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      {item?.status == "completed" && (
        <div className="Table_data_show Table_data_show1 pt-0">
          <h2 className="ps-3 pt-2 pb-2">Check-in / Check-out Details</h2>
          <table className="bg-primary-secondary table">
            <tbody>
              <tr>
                <td className="bg-primary-secondary" style={{ width: "20%" }}>
                  Check-in Datetime:
                </td>
                <td className="bg-primary-secondary" colSpan={3}>
                  {item?.appointment_assign?.checkin_date +
                    " " +
                    item?.appointment_assign?.checkin_time}
                </td>
                <td className="bg-primary-secondary" style={{ width: "20%" }}>
                  Check-out Datetime:
                </td>
                <td className="bg-primary-secondary" colSpan={3}>
                  {item?.appointment_assign?.checkout_date +
                    " " +
                    item?.appointment_assign?.checkout_time}
                </td>
              </tr>
              <tr>
                {/* <td className="bg-primary-secondary" style={{ width: "20%" }}>Comments:</td>
                                <td className="bg-primary-secondary" colSpan={3}>{item?.appointment_assign?.comments}</td> */}
                <td className="bg-primary-secondary" style={{ width: "20%" }}>
                  Notes:
                </td>
                <td className="bg-primary-secondary" colSpan={3}>
                  {item?.appointment_assign?.notes}
                </td>
                <td className="bg-primary-secondary" style={{ width: "20%" }}>
                  Mileage:
                </td>
                <td className="bg-primary-secondary" colSpan={5}>
                  {item?.appointment_assign?.mileage}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* <div className="profile-section">
                <h2>Basic Detail</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Appointment ID:" value={item?.appid} />
                    <InfoRow label="Status:" value={item?.status} />
                    <InfoRow label="Date:" value={item?.date} />
                    <InfoRow label="Time:" value={item?.start_time} />
                    <InfoRow label="Appointment Type:" value={item?.type} />
                    <InfoRow label="Language:" value={item?.language?.name} />
                    <InfoRow label="Facility:" value={item?.appointment_details?.facility?.abbreviation} />
                    <InfoRow label="Department:" value={item?.appointment_details?.department?.department_name} />
                    <InfoRow label="Estimated Duration:" value={`${item.duration} minutes`} />
                    <InfoRow label="Facility Address:" value={item.appointment_details?.facility?.address} />
                </div>
            </div> */}
      {/* <div className="profile-section">
                <h2>Client Information</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Client Name:" value={item?.accounts?.user?.name} />
                    <InfoRow label="Client Email:" value={item?.accounts?.user?.email} toLowerCase={'text-lowercase'} />
                    <InfoRow label="Client Phone:" value={item?.accounts?.phone} />
                </div>
            </div> */}
      {/* {(item?.interpreter || item?.vendor) &&
                <div className="profile-section">
                    <h2>Interpreter / Vendor</h2>
                    <div className='row_sec_wrapper'>
                        {item?.interpreter &&
                            <>
                                {item?.interpreter?.vendor ?
                                    <InfoRow label="Interpreter Name:" value={item?.interpreter?.user?.name + ' - ' + item?.interpreter?.vendor?.name} />
                                    :
                                    <InfoRow label="Interpreter Name:" value={item?.interpreter?.user?.name} />
                                }
                                <InfoRow label="Interpreter Email:" value={item?.interpreter?.user?.email} toLowerCase={'text-lowercase'} />
                                <InfoRow label="Interpreter Phone:" value={item?.interpreter?.phone} />
                            </>
                        }
                        {item?.vendor &&
                            <>
                                <InfoRow label="Vendor Name:" value={item?.vendor?.name} />
                                <InfoRow label="Vendor Email:" value={item?.vendor?.email} toLowerCase={'text-lowercase'} />
                            </>
                        }
                    </div>
                </div>
            } */}

      {/* <div className="profile-section">
                <h2>Patient Information</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Patient Name:" value={item.appointment_details?.patient?.patient_name} />
                    <InfoRow label="Patient Phone:" value={item.appointment_details?.patient_phone} />
                    <InfoRow label="Patient Birthdate:" value={item.appointment_details?.patient?.birth_date} />
                    <InfoRow label="MRN Number:" value={item.appointment_details?.patient?.mrn_number} />
                    <InfoRow label="Medicaid Id:" value={item.appointment_details?.patient?.medicaid_id} />
                    <InfoRow label="Medicaid Plan:" value={item.appointment_details?.patient?.medicaid_plan} />
                </div>
            </div> */}

      {/* <div className="profile-section">
                <h2>Requestor Information</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Requester Name:" value={item.appointment_details?.requester_name} />
                    <InfoRow label="Requester Email:" value={item.appointment_details?.requester_email} toLowerCase={'text-lowercase'} />
                    <InfoRow label="Requester Phone:" value={item.appointment_details?.requester_phone} />
                </div>
            </div> */}
      {/* <div className="profile-section">
                <h2>Appointment Detail</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Priority Level:" value={item.appointment_details?.priority_level} />
                    <InfoRow label="Provider Name:" value={item.appointment_details?.provider_name} />
                    <InfoRow label="Special Instruction:" value={item.appointment_details?.special_instruction} />
                    <InfoRow label="Encounter Source:" value={item.appointment_details?.encounter_source} />
                    <InfoRow label="Reschedule reason:" value={item?.appointment_details?.reschedule_reason} />
                    <InfoRow label="CNC reason:" value={item?.appointment_details?.cnc_reason} />
                    <InfoRow label="DNC reason:" value={item?.appointment_details?.dnc_reason} />
                    <InfoRow label="Cancel reason:" value={item?.appointment_details?.cancel_reason} />
                </div>
            </div> */}
      {/* <div className="profile-section">
                <h2>Checkin/Checkout Deatils</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Checkin Date:" value={item.appointment_assign?.checkin_date} />
                    <InfoRow label="Checkin Time:" value={item.appointment_assign?.checkin_time} />
                    <InfoRow label="Checkout Date:" value={item.appointment_assign?.checkout_date} />
                    <InfoRow label="Checkout Time:" value={item.appointment_assign?.checkout_time} />
                    <InfoRow label="Comments:" value={item.appointment_assign?.comments} />
                    <InfoRow label="Notes:" value={item.appointment_assign?.notes} />
                </div>
            </div> */}
    </div>
  );
});

export default ViewTable;
